import { t as e } from "../../chunks/cn.CW-jpn-X.js";
import { t } from "../../chunks/dist.10W5_QHK.js";
import { jsx as n } from "react/jsx-runtime";
// lib/components/CropDialog/GridLine.tsx
var r = ({ direction: r, offset: i }) => {
	let a = t("\n    absolute\n    opacity-50\n    pointer-events-none\n    transition-[opacity]\n    ease-in-out\n    duration-200\n    group-[.grid]:opacity-50", { variants: { direction: {
		horizontal: "left-0 right-0 h-[1px]",
		vertical: "top-0 bottom-0 w-[1px]"
	} } }), o = { backdropFilter: "invert(0.8)" };
	return r === "vertical" ? o.left = `${i}%` : o.top = `${i}%`, /* @__PURE__ */ n("div", {
		className: e(a({ direction: r })),
		style: o
	});
};
export { r as GridLine };
